// extracted by mini-css-extract-plugin
export default {"label":"TypeField__label-ssm0g","tooltip":"TypeField__tooltip-_KRlv"};